import React from 'react';
import {
    Card, CardBody, CardTitle,
    CardText, Col, Row, Container
} from 'reactstrap';
import AuthComponent from '../components/AuthComponent'
import MapComponent from "../components/MapComponent";
import '../styles/LinkPage.css'

export default class LodgingPage extends AuthComponent {

    render() {
        return (
            <Container className="LinkPage">
                <h4>ALLOGGI CONSIGLIATI PER IL RADUNO 2025</h4>
                <h6>Questo e' un un’elenco degli alberghi di Pieve di Soligo e dintorni (tutti includono la colazione),
                    che vi consigliamo. Le prenotazioni vanno fatte direttamente da voi. 
                
                </h6>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Locanda da Lino</CardTitle>
                                <CardText>Via Roma, 19 
                                <br />31053 Pieve di Soligo TV
                                <br />0438 82150
                                <br /><a href="https://www.locandadalino.it/la-locanda-da-lino-solighetto/" 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Locanda da Lino</a></CardText>
                                <CardText>Prezzo: singola €80; doppia €120</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.91768681771794} lng={12.163401534629473} name="Locanda da Lino"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Hotel del Parco - Albergo Loris</CardTitle>
                                <CardText>Via Suoi, 10
                                <br />31053 Pieve di Soligo TV
                                <br />+39043882880
                                <br /><a href="https://www.hoteldelparco.it " 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Hotel del Parco</a></CardText>
                                <CardText>Dispone di 20 camere doppie da € 140. Segnalate all’hotel di essere del Clan Schiratti</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.91001249865701} lng={12.188517569640663} name="Hotel del Parco"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Hotel Contà</CardTitle>
                                <CardText>via Borgo Stolfi n°25
                                <br />31053 Pieve di Soligo TV
                                <br />+39043882880
                                <br /><a href="https://www.hotelconta.it  " 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Hotel Contà</a></CardText>
                                <CardText>a partire da € 102</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.90142491991691} lng={12.174937050656451} name="Hotel Contà"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Hotel Canon d'Oro</CardTitle>
                                <CardText>Via XX Settembre, 131
                                <br />31015 Conegliano TV
                                <br />+39 3270725870
                                <br /><a href="https://www.hotelcanondoro.it/  " 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Hotel Canon d'Oro</a></CardText>
                                <CardText>offre ai clienti che gli segnalino di essere del Clan Schiratti indicandolo nelle mail di prenotazione, 
                                    il 15% di sconto sulla tariffa di listino della camera (solo pernottamento) per le prenotazioni effettuate 
                                    direttamente: via email a info@relaisladolcevite.it o telefonicamente al numero +39 3270725870.</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.88811497390815} lng={12.2997178020189} name="Hotel Canon d'Oro"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Bed & Breakfast Villa Margherita</CardTitle>
                                <CardText>Via Lamberto Chisini, 70
                                <br />31053 Pieve di Soligo TV
                                <br />+393495233239
                                <br /><a href="http://www.villamargheritapieve.it/" 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Villa Margherita</a></CardText>
                                <CardText></CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.897262266912826} lng={12.176319634754645} name="Villa Margherita"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Bed & Breakfast "Alle Zagare"</CardTitle>
                                <CardText>Via della Vittoria, 63
                                <br />31020 Refrontolo TV
                                <br />+393356001279
                                <br /><a href="http://www.allezagare.it/" 
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">Alle Zagare</a></CardText>
                                <CardText>Camera matrimoniale €120 e camera doppia con seconda camera a 2 letti cioè 4 persone €150</CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.91497850078238} lng={12.201616033481292} name="Alle Zagare"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Airbnb: ApArt di Rebecca Schiratti 692</CardTitle>
                                <CardText>Via Gera, 4
                                <br />31015 Conegliano(Tv)
                                <br />+39 3382241104
                                <br /><a href="https://www.airbnb.com/rooms/1231820038756486860?source_impression_id=p3_1746227143_P3jwyCkVdttrc4Zu"
                                style={{cursor: 'pointer'}} target="_blank" rel="noopener noreferrer">ApArt</a></CardText>
                                <CardText>Intero alloggio: ci sono due camere e due bagni 
                                <br />una matrimoniale e una con letto a castello (4 posti letto) a €165 a notte.
                                <br />Rebecca abita nell’appartamento sopra. Non prenotate su Airbnb, ma contattate direttamente Rebecca.                                
                                </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.88270051846526} lng={12.292235607476854} name="Conegliano"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle> Agriturismo "Le Pervinche"</CardTitle>
                                <CardText>Via Molinetto, 8A,
                                <br />31020 Refrontolo TV
                                <br />+39 347 228 9508
                                <br /><a href="http://www.lepervinche.it/" style={{cursor: 'pointer'}} target="_blank"
                                rel="noopener noreferrer" >Le Pervinche</a></CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.92707372539609} lng={12.200535980591068} name="Le Pervinche"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                <Row className="section-panel">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>Campeggio a “Le Crode” a Collalto di Susegana </CardTitle>
                                <CardText>Via Strada di Collalto, 2/A
                                <br />31058 Collalto TV
                               </CardText>
                                <CardText>Emanuele Ricci 636 come nel passato, mette a disposizione, anche a partire dal 25 agosto,
                                    il prato dietro la casa rurale per chi vuole campeggiare (è stato fatto lì anche nel 1995, 2000, ecc.).        
                                    <br />L’accesso è da via Strada per Collalto 2/A Susegana 
                                    <br />dal cancello di ferro dopo il ponte sul torrente Lierza andando 
                                    da Barbisano, a Collalto, frazione di Susegana. 
                                    Sarà messa a disposizione una fontana d’acqua e wc chimico che verrà affittato. </CardText>
                            </CardBody>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <CardBody>
                                <div key={1} >
                                    <MapComponent lat={45.873196881663596} lng={12.19310187828051} name="Campeggio Manu Ricci"/>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        );
    }
}

